import { Variant } from "@components/buttons/Button";
import type { ModalProps as AntdModalProps } from "antd";
import { Modal as AntdModal } from "antd";
import { Button } from "index";
import React from "react";

export interface ModalProps extends AntdModalProps {
  ariaLabel?: string;
  cancelVariant?: Variant;
  okVariant?: Variant;
}
const Modal = ({
  ariaLabel,
  cancelText = "Cancel",
  cancelVariant = "utility",
  cancelButtonProps,
  confirmLoading,
  okButtonProps,
  okText = "OK",
  okVariant = "primary",
  onOk,
  ...props
}: ModalProps) => {
  const mappedOkProps = {
    ...okButtonProps,
    loading: confirmLoading ?? okButtonProps?.loading,
  };

  const footer = (
    <>
      {cancelText ? (
        <Button
          onClick={props.onCancel}
          variant={cancelVariant}
          {...cancelButtonProps}
        >
          {cancelText}
        </Button>
      ) : null}
      {okText ? (
        <Button onClick={onOk} variant={okVariant} {...mappedOkProps}>
          {okText}
        </Button>
      ) : null}
    </>
  );

  return (
    <AntdModal
      centered
      zIndex={10000}
      aria-label={ariaLabel}
      footer={props.footer ?? footer}
      {...props}
    />
  );
};

Modal.confirm = AntdModal.confirm;
Modal.error = AntdModal.error;
Modal.info = AntdModal.info;
Modal.success = AntdModal.success;
Modal.warning = AntdModal.warning;

Modal.useModal = AntdModal.useModal;

export default Modal;
